import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlUtilsService {

  constructor() { }

  removeProtocolFromUrl(url: string): string
  {
    if(!url){
      return null;
    }
    
    var newUrl =   url.replace(/^https?:\/\//, '');
    newUrl =   newUrl.replace(/^http?:\/\//, '');

    return newUrl;
  }
}
